import { MatchListStore } from "./matchList/MatchListStore";
import { CreateLeagueMatchStore } from "./nationalLeague/CreateLeagueMatchStore";
import { NationalLeagueStore } from "./nationalLeague/NatioanlLeagueStore";

export class RootStore {
  matchListStore: MatchListStore;
  nationalLeagueStore: NationalLeagueStore;
  createLeagueMatchStore: CreateLeagueMatchStore;

  constructor() {
    this.matchListStore = new MatchListStore(this);
    this.nationalLeagueStore = new NationalLeagueStore(this);
    this.createLeagueMatchStore = new CreateLeagueMatchStore(this);
  }
}

// Create a single instance of the store
const rootStore = new RootStore();
export default rootStore;
